import { render, staticRenderFns } from "./ReviewOpteration.vue?vue&type=template&id=519ce5e9&scoped=true&"
import script from "./ReviewOpteration.vue?vue&type=script&lang=js&"
export * from "./ReviewOpteration.vue?vue&type=script&lang=js&"
import style0 from "./ReviewOpteration.vue?vue&type=style&index=0&id=519ce5e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ce5e9",
  null
  
)

export default component.exports